module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-left"
  }, [_c('div', {
    staticClass: "logo"
  }, [(_vm.entity.name == 'amigo') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/amigo.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'amicitia') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/amicitia.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'hannick') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/hannick.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'friendshipcruises') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/friendshipcruises.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'davincitravel') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/davincitravel.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'aircruise') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/aircruise.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'ncrv-reizen') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/ncrv-reizen.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'agro') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/agro.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "menu-container"
  }, [_c('nav', {
    staticClass: "navbar-mijnomgeving"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/my-dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\r\n          Home\r\n        ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/my-personal-info"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "personalPronoun"
    }
  }), _vm._v(" Gegevens\r\n        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/my-reservations"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\r\n          Contact\r\n        ")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logOut
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\r\n          Uitloggen\r\n        ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu-button"
  }, [_c('a', {
    staticClass: "menu-toggle",
    on: {
      "click": _vm.menuToggle
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu"
  }, [_c('nav', {
    staticClass: "navbar-mijnomgeving"
  }, [_c('ul', {
    staticClass: "menu-mobile"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/my-dashboard"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/my-personal-info"
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronoun"
    }
  }), _vm._v(" gegevens\r\n          ")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/my-reservations"
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("Uitloggen")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "bars"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4296c387"}!./src/templates/menu-left.html
// module id = 537
// module chunks = 1